import SportCode from "components/common/SportCode";
import Competitor from 'components/presentation/Competitor';
import { DefaultRenderCompetitor } from 'components/general/Pbp';
import Label from "components/general/Label";
import Accordion from 'react-bootstrap/Accordion';
import { useViewport } from 'components/general/useViewPort';
import NotAvailable from 'components/common/NotAvailable';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const VvoCenterRender = ({ rally }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  let [a, b, c, d] = ['', '', '', ''];

  let actionScore = rally?.actions?.find(a => a.pbpa_ScoreH)
  let actionRally = rally?.actions?.find(a => a.pbpa_Rally)

  if (rally?.actions?.find(a => a.competitors) === undefined) a = (<div className='fw-bold'><SportCode discipline={mirs_discipline} entity='@ActionComment' code={rally?.actions[0].pbpa_Comment} /></div>);

  if (rally?.actions[0]?.pbpa_When && rally?.actions?.find(a => a.pbpa_Action !== 'STARTP')) b = (<div>{rally?.actions[0]?.pbpa_When}</div>);

  if (actionScore) {
    c = (<div className='fw-bolder'>{actionScore?.pbpa_ScoreH} - {actionScore?.pbpa_ScoreA}</div>);
  }

  if (rally?.actions?.find(a => a.pbpa_Action !== 'STARTP') && actionRally?.pbpa_Rally) {
    d = actionRally?.pbpa_Rally
  }

  if (rally?.actions?.find(a => a.pbpa_Action !== 'STARTP') && !actionRally?.pbpa_Rally) {
    d = '-'
  }

  return (
    <div className='h-100'>

      {d
        ? breakPoint === "sm" || breakPoint === "xs"
          ? <><div className='col-7'><div className="box-center text-center">{a}{b}{c}</div></div>
            <div className='justify-content-center col-5 d-flex align-items-center'><div className="box-center ">{d}</div></div></>
          : <><div className='col-8'><div className="box-center text-center">{a}{b}{c}</div></div>
            <div className='justify-content-center col-4 d-flex align-items-center'><div className="box-center text-center">{d}</div></div></>
        : <><div className='h-100 box-center justify-content-center col fw-bold d-flex align-items-center'>{a}{b}{c}</div></>
      }

    </div>
  );
}

const VvoSideRender = ({ rally, home, away }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  return rally?.actions?.map((action, index) => {

    const compHome = action?.competitors?.find(item => item.pbpc_code === home.participant?.code)
    const compAway = action?.competitors?.find(item => item.pbpc_code === away.participant?.code)

    if (!compHome && action?.pbpa_Action === 'STARTP') {
      return (<div key={index}>
        <div><Starters homeAway={home} currSet={action?.pbpa_period}></Starters></div>
        <div><Starters homeAway={away} currSet={action?.pbpa_period}></Starters></div>
      </div>);
    }

    if (!compHome && !compAway) return;

    return (
      <div key={index}>
        {compHome
          ? <div><div className="d-flex flex-row">
            <div><DefaultRenderCompetitor comp={compHome} homeAway={home} action={action} /></div>
            <div>
              {action?.pbpa_Action === 'SRV' && action?.pbpa_Speed
                ? <><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                  <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />,&nbsp;
                  <Label data='HeaderServeSpeed' sport='VVO' />&nbsp;{action?.pbpa_Speed}<Label data='LabelKMH' /></>
                : action?.pbpa_Action === 'SUBST'
                  ? <><SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></>
                  : <><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                    <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></>
              }
            </div>
          </div>
          </div>
          : <></>
        }
        {compAway
          ? <div><div className="d-flex flex-row">
            <div><DefaultRenderCompetitor comp={compAway} homeAway={away} action={action} /></div>
            <div>
              {action?.pbpa_Action === 'SRV' && action?.pbpa_Speed
                ? <><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                  <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />,&nbsp;
                  <Label data='HeaderServeSpeed' sport='VVO' />&nbsp;{action?.pbpa_Speed}<Label data='LabelKMH' /></>
                : action?.pbpa_Action === 'SUBST'
                  ? <><SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></>
                  : <><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                    <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></>
              }
            </div>
          </div>
          </div>
          : <></>
        }
      </div>
    )
  })
}

const Starters = ({ homeAway, currSet }) => {
  const starters = homeAway?.teamAthletes?.filter(a => a?.extResults?.find(eu => eu?.er_code === 'POSITION' && eu?.er_pos === currSet))
  starters.sort((a, b) => a.extResults?.find(eu => eu?.er_code === 'POSITION' && eu?.er_pos === currSet).er_value
    - b.extResults?.find(eu => eu?.er_code === 'POSITION' && eu?.er_pos === currSet).er_value)
  return (<>
    <Competitor hidePicture={true} alwaysNoc={true} {...homeAway?.participant} />
    {starters.map(s => (
      <div key={s?.athlete?.code} className='d-flex flex-row'>
        <span>{s.extResults?.find(eu => eu?.er_code === 'POSITION' && eu?.er_pos === currSet).er_value}.&nbsp;</span>
        {s.bib}&nbsp;
        <Competitor key={s?.athlete?.code} hideNoc={true} hidePicture={true} {...s?.athlete} />
      </div>
    ))}
  </>)
}

const VvoHeader = () => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  return (
    <>
      <div className='row box-center'>
        {breakPoint === "sm" || breakPoint === "xs"
          ? <> <div className="col-1 fw-bold"><Label data='HeaderTime' /></div>&nbsp;&nbsp;
            <div className='col-2 fw-bold text-center'><Label data='HeaderRally' sport={mirs_discipline} /></div>
            <div className='col-9'></div></>
          : <> <div className="col-2 fw-bold text-center"><Label data='HeaderTime' /></div>
            <div className='col-1 fw-bold text-center'><Label data='HeaderRally' sport={mirs_discipline} /></div>
            <div className='col-9'></div></>
        }
      </div>
    </>
  )
}

const getPeriodOrder = (periodsOrder, period) => {
  return periodsOrder?.find(i => i.period === period)?.order;
}

const RenderAccordion = ({ data, config }) => {
  const handleClick = (e) => {
    // console.log(e);
  }
  let out = (<NotAvailable />)

  if (data?.results?.playByPlay?.length > 0) {
    let periods = data.results.playByPlay;
    if (config.reverseSorting) {
      periods?.sort((a, b) => getPeriodOrder(config?.periodsOrder, b.subcode) - getPeriodOrder(config?.periodsOrder, a.subcode));
    } else {
      periods?.sort((a, b) => getPeriodOrder(config?.periodsOrder, a.subcode) - getPeriodOrder(config?.periodsOrder, b.subcode));
    }

    out = (
      <Accordion defaultActiveKey={periods[0].subcode} onClick={(e) => handleClick(e)}>
        <RenderPeriods periods={periods} home={data.results.home} away={data.results.away} config={config} />
      </Accordion>
    )

  }
  return out;
}

const RenderPeriods = ({ periods, home, away, config }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const RenderHeader = config?.headerRender
  return periods?.map(item => {
    let rallies = [];
    item?.actions?.forEach(a => {
      if (!a.pbpa_Rally) {
        rallies.push({
          rally: "-",
          actions: [a],
          order: a?.pbpa_order
        })
      } else {
        let b = rallies?.find(r => r.rally === a?.pbpa_Rally);
        if (b) {
          b.actions.push(a)
        } else {
          rallies.push({
            rally: a?.pbpa_Rally,
            actions: [a],
            order: a?.pbpa_order
          })
        }
      }
    });
    return (
      <Accordion.Item id={`mirs-accordion-item-${item.subcode}`} eventKey={item.subcode} key={item.subcode}>
        <Accordion.Header><SportCode discipline={mirs_discipline} entity='@Period' code={item.subcode} /></Accordion.Header>
        <Accordion.Body>
          <RenderHeader home={home} away={away} />
          <RenderSinglePeriod rallies={rallies} home={home} away={away} config={config} />
        </Accordion.Body>
      </Accordion.Item>
    )
  }
  )
}

const RenderAction = ({ rally, home, away, config }) => {
  const SideRender = config?.sideRender
  const CenterRender = config?.centerRender

  const pointsLeft = (
    <div className="row" key={rally.order + rally.rally}>
      <div className="col-3"><CenterRender rally={rally} /></div>
      {rally?.actions?.find(a => a.pbpa_Action === 'ENDP')
        ? <><div className="col-9">
          <SideRender rally={rally} home={home} away={away} />
        </div></>
        : <><div className="col-9">
          <div className="box">
            <SideRender rally={rally} home={home} away={away} /></div>
        </div></>
      }
    </div>
  )
  return pointsLeft

}

const RenderSinglePeriod = ({ rallies, home, away, config }) => {
  return rallies?.map((item, index) => {
    return <div key={index}><RenderAction rally={item} home={home} away={away} config={config} key={item.pbpa_id} /></div>
  })
}

function VvoPbp({ data, periodsOrder }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()

  const configPbp = {
    centerRender: VvoCenterRender,
    sideRender: VvoSideRender,
    headerRender: VvoHeader,
    layout: "points_left",
    periodsOrder: periodsOrder,
    reverseSorting: true
  }
  return (
    <div className="pbp-main" id={`mirs-accordion-play-by-play-${mirs_rsc}`}>
      <RenderAccordion data={data} config={configPbp} />
    </div>
  )
}

export default VvoPbp;